"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unsupported_exports = {};
__export(unsupported_exports, {
  Swift: () => Swift
});
module.exports = __toCommonJS(unsupported_exports);
var import_unsupportedControls = require("./generated/unsupportedControls");
var import_ArrangementView = require("./ArrangementView");
var import_keyframes = require("./keyframes");
function Tabs(_props) {
  throw new Error("Swift.Tabs requires an iOS native build");
}
function Tab(_props) {
  throw new Error("Swift.Tab requires an iOS native build");
}
function TabSection(_props) {
  throw new Error("Swift.TabSection requires an iOS native build");
}
function TabViewBottomAccessory(_props) {
  throw new Error("Swift.TabViewBottomAccessory requires an iOS native build");
}
function TabViewSlot(_props) {
  throw new Error("Swift.TabViewSlot requires an iOS native build");
}
function Menu(_props) {
  throw new Error("Swift.Menu requires an iOS native build");
}
function ContextMenu(_props) {
  throw new Error("Swift.ContextMenu requires an iOS native build");
}
function Sheet(_props) {
  throw new Error("Swift.Sheet requires an iOS native build");
}
function FullScreenCover(_props) {
  throw new Error("Swift.FullScreenCover requires an iOS native build");
}
function Popover(_props) {
  throw new Error("Swift.Popover requires an iOS native build");
}
function Host(_props) {
  throw new Error("Swift.Host requires an iOS native build");
}
function HStack(_props) {
  throw new Error("Swift.HStack requires an iOS native build");
}
function VStack(_props) {
  throw new Error("Swift.VStack requires an iOS native build");
}
function ZStack(_props) {
  throw new Error("Swift.ZStack requires an iOS native build");
}
function Spacer(_props) {
  throw new Error("Swift.Spacer requires an iOS native build");
}
function Form(_props) {
  throw new Error("Swift.Form requires an iOS native build");
}
function Section(_props) {
  throw new Error("Swift.Section requires an iOS native build");
}
function LabeledContent(_props) {
  throw new Error("Swift.LabeledContent requires an iOS native build");
}
function GroupBox(_props) {
  throw new Error("Swift.GroupBox requires an iOS native build");
}
function ViewThatFits(_props) {
  throw new Error("Swift.ViewThatFits requires an iOS native build");
}
function Button(_props) {
  throw new Error("Swift.Button requires an iOS native build");
}
function Glass(_props) {
  throw new Error("Swift.Glass requires an iOS native build");
}
function GlassEffectContainer(_props) {
  throw new Error("Swift.GlassEffectContainer requires an iOS native build");
}
function GeometryReader(_props) {
  throw new Error("Swift.GeometryReader requires an iOS native build");
}
function Slot(_props) {
  throw new Error("Swift.Slot requires an iOS native build");
}
function List(_props) {
  throw new Error("Swift.List requires an iOS native build");
}
function ScrollViewReader(_props) {
  throw new Error("Swift.ScrollViewReader requires an iOS native build");
}
function ScrollView(_props) {
  throw new Error("Swift.ScrollView requires an iOS native build");
}
function LazyVStack(_props) {
  throw new Error("Swift.LazyVStack requires an iOS native build");
}
function LazyHStack(_props) {
  throw new Error("Swift.LazyHStack requires an iOS native build");
}
function LazyVGrid(_props) {
  throw new Error("Swift.LazyVGrid requires an iOS native build");
}
function LazyHGrid(_props) {
  throw new Error("Swift.LazyHGrid requires an iOS native build");
}
function Grid(_props) {
  throw new Error("Swift.Grid requires an iOS native build");
}
function GridRow(_props) {
  throw new Error("Swift.GridRow requires an iOS native build");
}
function ControlGroup(_props) {
  throw new Error("Swift.ControlGroup requires an iOS native build");
}
function DisclosureGroup(_props) {
  throw new Error("Swift.DisclosureGroup requires an iOS native build");
}
function Divider(_props) {
  throw new Error("Swift.Divider requires an iOS native build");
}
function Link(_props) {
  throw new Error("Swift.Link requires an iOS native build");
}
function Group(_props) {
  throw new Error("Swift.Group requires an iOS native build");
}
function OverlayContent(_props) {
  throw new Error("Swift.Overlay.Content requires an iOS native build");
}
function OverlayFn(_props) {
  throw new Error("Swift.Overlay requires an iOS native build");
}
var Overlay = Object.assign(OverlayFn, {
  Content: OverlayContent
});
function ViewSlotFn(_props) {
  throw new Error("Swift.ViewSlot requires an iOS native build");
}
var ViewSlot = Object.assign(ViewSlotFn, {
  Content: OverlayContent
});
function SwipeActionsActions(_props) {
  throw new Error("Swift.SwipeActions.Actions requires an iOS native build");
}
function SwipeActionsFn(_props) {
  throw new Error("Swift.SwipeActions requires an iOS native build");
}
var SwipeActions = Object.assign(SwipeActionsFn, {
  Actions: SwipeActionsActions
});
function Page(_props) {
  throw new Error("Swift.Page requires an iOS native build");
}
function Pager(_props) {
  throw new Error("Swift.Pager requires an iOS native build");
}
function NavigationStack(_props) {
  throw new Error("Swift.NavigationStack requires an iOS native build");
}
function NavigationSplitViewFn(_props) {
  throw new Error("Swift.NavigationSplitView requires an iOS native build");
}
function NavigationSplitViewSidebar(_props) {
  throw new Error("Swift.NavigationSplitView.Sidebar requires an iOS native build");
}
function NavigationSplitViewContent(_props) {
  throw new Error("Swift.NavigationSplitView.Content requires an iOS native build");
}
function NavigationSplitViewDetail(_props) {
  throw new Error("Swift.NavigationSplitView.Detail requires an iOS native build");
}
var NavigationSplitView = Object.assign(NavigationSplitViewFn, {
  Sidebar: NavigationSplitViewSidebar,
  Content: NavigationSplitViewContent,
  Detail: NavigationSplitViewDetail
});
function ToolbarMarker(_props) {
  throw new Error("Swift.Toolbar requires an iOS native build");
}
function ToolbarContent(_props) {
  throw new Error("Swift.Toolbar.Content requires an iOS native build");
}
var Toolbar = Object.assign(ToolbarMarker, {
  Content: ToolbarContent
});
function ToolbarItem(_props) {
  throw new Error("Swift.ToolbarItem requires an iOS native build");
}
function ToolbarItemGroup(_props) {
  throw new Error("Swift.ToolbarItemGroup requires an iOS native build");
}
function ToolbarSpacer(_props) {
  throw new Error("Swift.ToolbarSpacer requires an iOS native build");
}
function MapWithControlsStub(_props) {
  throw new Error("Swift.Map requires an iOS native build");
}
function PhaseAnimator(_props) {
  throw new Error("Swift.PhaseAnimator requires an iOS native build");
}
function KeyframeAnimator(_props) {
  throw new Error("Swift.KeyframeAnimator requires an iOS native build");
}
var Swift = {
  ArrangementView: import_ArrangementView.ArrangementView,
  Tabs,
  Tab,
  TabSection,
  TabViewBottomAccessory,
  TabViewSlot,
  Menu,
  ContextMenu,
  Sheet,
  FullScreenCover,
  Popover,
  Host,
  HStack,
  VStack,
  ZStack,
  Form,
  Section,
  Glass,
  GlassEffectContainer,
  GeometryReader,
  LabeledContent,
  Button,
  Spacer,
  Slot,
  List,
  ScrollView,
  ScrollViewReader,
  LazyVStack,
  LazyHStack,
  LazyVGrid,
  LazyHGrid,
  Grid,
  GridRow,
  ControlGroup,
  DisclosureGroup,
  Divider,
  Link,
  Group,
  GroupBox,
  ViewThatFits,
  Overlay,
  ViewSlot,
  SwipeActions,
  Pager,
  Page,
  NavigationStack,
  NavigationSplitView,
  Toolbar,
  ToolbarItem,
  ToolbarItemGroup,
  ToolbarSpacer,
  PhaseAnimator,
  KeyframeAnimator,
  KeyframeTrack: import_keyframes.KeyframeTrack,
  LinearKeyframe: import_keyframes.LinearKeyframe,
  SpringKeyframe: import_keyframes.SpringKeyframe,
  CubicKeyframe: import_keyframes.CubicKeyframe,
  MoveKeyframe: import_keyframes.MoveKeyframe,
  withAnimation(_animation, _body, _completion, _completionCriteria) {
    throw new Error("Swift.withAnimation requires an iOS native build");
  },
  ...import_unsupportedControls.unsupportedControls,
  Map: MapWithControlsStub
};
//# sourceMappingURL=unsupported.js.map
